import React, { useState } from "react";
import SidebarTab from "../../../Components/Sidebar/SidebarTab";
import { useLocation } from "react-router-dom";
import { useSelector } from "react-redux";
import { userPermissions } from "../../../Utils/constants";

const Sidebar = ({ profile, setProfile, activeLink }) => {
  const permissions = useSelector((state) => state.user.permissions);
  const role = useSelector((state) => state.user.role);
  const location = useLocation();

  const [active, setActive] = useState(
    activeLink ||
      location?.pathname?.split("card").length > 1 ||
      location?.pathname?.split("project").length > 1
      ? "dashboard"
      : location?.pathname?.split("/")[2] || "dashboard"
  );

  return (
    <div className="flex z-[200000000] md:flex-row grow w-[350px]">
      <div className="sm:pl-8 h-full pl-6 fixed bg-white pb-[100px] overflow-x-visible">
        <div className="flex flex-col space-y-2 overflow-y-scroll h-full scrollbar-hide">
          <SidebarTab
            value="dashboard"
            setActive={setActive}
            setProfile={setProfile}
            active={active}
            profile={profile}
          />
          {permissions.includes(`admin-${role.toLowerCase()}`) ||
            permissions.includes(userPermissions.job.view) ? (
            <SidebarTab
              value="discover"
              setActive={setActive}
              setProfile={setProfile}
              active={active}
              profile={profile}
            />
          ) : null}
          {permissions.includes(`admin-${role.toLowerCase()}`) ||
            [
              userPermissions.job.view,
              userPermissions.job.add,
              userPermissions.job.edit,
            ].some((Permission) => permissions.includes(Permission)) ? (
            <SidebarTab
              value="jobs"
              setActive={setActive}
              setProfile={setProfile}
              active={active}
              profile={profile}
            />
          ) : null}
          {permissions.includes(`admin-${role.toLowerCase()}`) ||
            permissions.includes(userPermissions.job.invoiceAction) ? (
            <SidebarTab
              value="invoices"
              setActive={setActive}
              setProfile={setProfile}
              active={active}
              profile={profile}
            />
          ) : null}
          {permissions.includes(`admin-${role.toLowerCase()}`) ||
            [
              userPermissions.vendorConnection.view,
              userPermissions.vendorConnection.add,
            ].some((Permission) => permissions.includes(Permission)) ? (
            <SidebarTab
              value="vendors"
              setActive={setActive}
              setProfile={setProfile}
              active={active}
              profile={profile}
            />
          ) : null}
          {permissions.includes(`admin-${role.toLowerCase()}`) ||
            [userPermissions.myAccount.view, userPermissions.myAccount.edit].some(
              (Permission) => permissions.includes(Permission)
            ) ? (
            <SidebarTab
              value="my-account"
              setActive={setActive}
              setProfile={setProfile}
              active={active}
              profile={profile}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
};

const SidebarWrapper = (props) => {
  return <Sidebar {...props} />;
};

export default SidebarWrapper;
